// 文件夹模块
const Folder = {
  state: {
  	//收件箱子文件夹
    inboxSub: [],
  },

  // 特别注意，子模块的mutations和getters、actions都是注册在全局store上的
  mutations: {
    // 更新收件箱子文件夹信息
    updateInboxSub(state, payload) {
      state.inboxSub = payload
    }
  },
  getters: {}
}

export default Folder



// WEBPACK FOOTER //
// ./src/store/folder.js